import { RenderableSprite3D } from "../RenderableSprite3D";
import { Event } from "../../../events/Event";
import { MeshSprite3DShaderDeclaration } from "../../../d3/core/MeshSprite3DShaderDeclaration";
import { Component } from "../../../components/Component";
import { Bounds } from "../../math/Bounds";
import { ReflectionProbe, ReflectionProbeMode } from "../../component/Volume/reflectionProbe/ReflectionProbe";
import { NodeFlags } from "../../../Const";
import { Sprite3DRenderDeclaration } from "./Sprite3DRenderDeclaration";
import { Shader3D } from "../../../RenderEngine/RenderShader/Shader3D";
import { Vector3 } from "../../../maths/Vector3";
import { Vector4 } from "../../../maths/Vector4";
import { VertexMesh } from "../../../RenderEngine/RenderShader/VertexMesh";
import { VolumetricGI } from "../../component/Volume/VolumetricGI/VolumetricGI";
import { Laya3DRender } from "../../RenderObjs/Laya3DRender";
import { LayaGL } from "../../../layagl/LayaGL";
import { StatElement } from "../../../layagl/StatisticsContext";
export var RenderBitFlag;
(function (RenderBitFlag) {
    RenderBitFlag[RenderBitFlag["RenderBitFlag_CullFlag"] = 0] = "RenderBitFlag_CullFlag";
    RenderBitFlag[RenderBitFlag["RenderBitFlag_Batch"] = 1] = "RenderBitFlag_Batch";
    RenderBitFlag[RenderBitFlag["RenderBitFlag_Editor"] = 2] = "RenderBitFlag_Editor";
    RenderBitFlag[RenderBitFlag["RenderBitFlag_InstanceBatch"] = 3] = "RenderBitFlag_InstanceBatch";
    RenderBitFlag[RenderBitFlag["RenderBitFlag_VertexMergeBatch"] = 4] = "RenderBitFlag_VertexMergeBatch";
})(RenderBitFlag || (RenderBitFlag = {}));
export var IrradianceMode;
(function (IrradianceMode) {
    IrradianceMode[IrradianceMode["LightMap"] = 0] = "LightMap";
    IrradianceMode[IrradianceMode["VolumetricGI"] = 1] = "VolumetricGI";
    IrradianceMode[IrradianceMode["Common"] = 2] = "Common";
})(IrradianceMode || (IrradianceMode = {}));
export class BaseRender extends Component {
    static __init__() {
        BaseRender.shaderValueInit();
    }
    static getMeshDefine(mesh, out) {
        out.length = 0;
        var define;
        for (var i = 0, n = mesh._subMeshes.length; i < n; i++) {
            var subMesh = mesh.getSubMesh(i);
            var vertexElements = subMesh._vertexBuffer.vertexDeclaration._vertexElements;
            for (var j = 0, m = vertexElements.length; j < m; j++) {
                var vertexElement = vertexElements[j];
                var name = vertexElement._elementUsage;
                switch (name) {
                    case VertexMesh.MESH_COLOR0:
                        out.push(MeshSprite3DShaderDeclaration.SHADERDEFINE_COLOR);
                        break;
                    case VertexMesh.MESH_TEXTURECOORDINATE0:
                        out.push(MeshSprite3DShaderDeclaration.SHADERDEFINE_UV0);
                        break;
                    case VertexMesh.MESH_TEXTURECOORDINATE1:
                        out.push(MeshSprite3DShaderDeclaration.SHADERDEFINE_UV1);
                        break;
                    case VertexMesh.MESH_TANGENT0:
                        out.push(MeshSprite3DShaderDeclaration.SHADERDEFINE_TANGENT);
                        break;
                    case VertexMesh.MESH_BLENDINDICES0:
                        out.push(MeshSprite3DShaderDeclaration.SHADERDEFINE_BONEI);
                        break;
                    case VertexMesh.MESH_BLENDWEIGHT0:
                        out.push(MeshSprite3DShaderDeclaration.SHADERDEFINE_BONEW);
                        break;
                }
            }
        }
        return define;
    }
    static changeVertexDefine(oldMesh, mesh, defineDatas) {
        var lastValue = oldMesh;
        if (lastValue) {
            BaseRender.getMeshDefine(lastValue, BaseRender._meshVerticeDefine);
            for (var i = 0, n = BaseRender._meshVerticeDefine.length; i < n; i++)
                defineDatas.removeDefine(BaseRender._meshVerticeDefine[i]);
        }
        if (mesh) {
            BaseRender.getMeshDefine(mesh, BaseRender._meshVerticeDefine);
            for (var i = 0, n = BaseRender._meshVerticeDefine.length; i < n; i++)
                defineDatas.addDefine(BaseRender._meshVerticeDefine[i]);
        }
    }
    static shaderValueInit() {
        Sprite3DRenderDeclaration.SHADERDEFINE_GI_LEGACYIBL = Shader3D.getDefineByName("GI_LEGACYIBL");
        Sprite3DRenderDeclaration.SHADERDEFINE_IBL_RGBD = Shader3D.getDefineByName("IBL_RGBD");
        Sprite3DRenderDeclaration.SHADERDEFINE_SPECCUBE_BOX_PROJECTION = Shader3D.getDefineByName("SPECCUBE_BOX_PROJECTION");
    }
    get enabled() {
        return super.enabled;
    }
    set enabled(value) {
        super.enabled = value;
        this._baseRenderNode.enable = value;
    }
    get sortingFudge() {
        return this._baseRenderNode.sortingFudge;
    }
    set sortingFudge(value) {
        this._baseRenderNode.sortingFudge = value;
    }
    get renderbitFlag() {
        return this._baseRenderNode.renderbitFlag;
    }
    get boundsChange() {
        return this._baseRenderNode.boundsChange;
    }
    set boundsChange(value) {
        this._baseRenderNode.boundsChange = value;
    }
    get renderNode() {
        return this._baseRenderNode;
    }
    get distanceForSort() {
        return this._baseRenderNode.distanceForSort;
    }
    set distanceForSort(value) {
        this._baseRenderNode.distanceForSort = value;
    }
    get geometryBounds() {
        return this._baseRenderNode.baseGeometryBounds;
    }
    set geometryBounds(value) {
        this._baseRenderNode.baseGeometryBounds = value;
    }
    get lightmapIndex() {
        return this._baseRenderNode.lightmapIndex;
    }
    set lightmapIndex(value) {
        this._baseRenderNode.lightmapIndex = value;
    }
    setLightmapIndex(value) {
        let scene = this._scene;
        if (value != -1 && (scene.lightmaps[value])) {
            this._baseRenderNode.lightmap = scene.lightmaps[value]._dataModule;
        }
        else {
            this._baseRenderNode.lightmap = null;
        }
        this._getIrradientMode();
    }
    get irradientMode() {
        return this._baseRenderNode.irradientMode;
    }
    get lightmapScaleOffset() {
        return this._lightmapScaleOffset;
    }
    set lightmapScaleOffset(value) {
        value.cloneTo(this._lightmapScaleOffset);
        this._baseRenderNode.setLightmapScaleOffset(this._lightmapScaleOffset);
    }
    get sharedMaterial() {
        return this._sharedMaterials[0];
    }
    set sharedMaterial(value) {
        var lastValue = this._sharedMaterials[0];
        this._changeMaterialReference(lastValue, value);
        this._sharedMaterials[0] = value;
        let element = this._renderElements[0];
        if (element && element.material != value) {
            this._materialsInstance[0] = false;
            element.material = value;
        }
        this._isSupportRenderFeature();
    }
    get sharedMaterials() {
        return this._sharedMaterials.slice();
    }
    set sharedMaterials(value) {
        var materialsInstance = this._materialsInstance;
        var sharedMats = this._sharedMaterials;
        if (value) {
            let count = value.length;
            for (let i = 0; i < count; i++) {
                let mat = value[i];
                let lastMat = sharedMats[i];
                this._changeMaterialReference(lastMat, mat);
                sharedMats[i] = mat;
                let element = this._renderElements[i];
                if (element && element.material != mat) {
                    materialsInstance[i] = false;
                    element.material = mat;
                }
            }
            for (let i = count, n = sharedMats.length; i < n; i++) {
                let mat = sharedMats[i];
                mat && mat._removeReference();
                let element = this._renderElements[i];
                element && (element.material = null);
            }
            materialsInstance.length = count;
            sharedMats.length = count;
        }
        else {
            for (let i = 0, n = sharedMats.length; i < n; i++) {
                let lastMat = sharedMats[i];
                lastMat && lastMat._removeReference();
            }
            this._sharedMaterials = [];
        }
        this._isSupportRenderFeature();
    }
    get bounds() {
        return this._baseRenderNode.bounds;
    }
    get receiveShadow() {
        return this._receiveShadow;
    }
    set receiveShadow(value) {
        if (this._receiveShadow !== value) {
            this._receiveShadow = value;
            if (value)
                this._baseRenderNode.shaderData.addDefine(RenderableSprite3D.SHADERDEFINE_RECEIVE_SHADOW);
            else
                this._baseRenderNode.shaderData.removeDefine(RenderableSprite3D.SHADERDEFINE_RECEIVE_SHADOW);
        }
        this._baseRenderNode.receiveShadow = value;
    }
    get castShadow() {
        return this._baseRenderNode.castShadow;
    }
    set castShadow(value) {
        this._baseRenderNode.castShadow = value;
    }
    get reflectionMode() {
        return this._baseRenderNode.reflectionMode;
    }
    set reflectionMode(value) {
        this._baseRenderNode.reflectionMode = value;
    }
    get volume() {
        return this._volume;
    }
    set volume(value) {
        if (!value) {
            if (this._volume) {
                this._volume._removeRenderNode && this._volume._removeRenderNode(this);
                this._volume = null;
            }
            return;
        }
        if (this._volume != value) {
            value._addRenderNode && value._addRenderNode(this);
            this._volume = value;
            return;
        }
        else {
            value._motionInVolume && value._motionInVolume(this);
        }
    }
    get probReflection() {
        return this._probReflection;
    }
    set probReflection(value) {
        if (this._probReflection == value)
            return;
        this._probReflection = value;
        const ReflectionProbeBlockName = ReflectionProbe.BlockName;
        if (value) {
            this._baseRenderNode.probeReflection = value._dataModule;
            this._baseRenderNode.additionShaderData.set(ReflectionProbeBlockName, value.shaderData);
        }
        else {
            this._baseRenderNode.probeReflection = null;
            this._baseRenderNode.additionShaderData.delete(ReflectionProbeBlockName);
        }
        this._baseRenderNode.additionShaderData = this._baseRenderNode.additionShaderData;
        this._getIrradientMode();
    }
    get lightProbe() {
        return this._lightProb;
    }
    set lightProbe(volumetricGI) {
        if (this._lightProb == volumetricGI) {
            return;
        }
        this._baseRenderNode.lightProbUpdateMark = -1;
        this._lightProb = volumetricGI;
        const VolumeGIBlockName = VolumetricGI.BlockName;
        if (volumetricGI) {
            this._baseRenderNode.volumetricGI = volumetricGI._dataModule;
            this._baseRenderNode.additionShaderData.set(VolumeGIBlockName, volumetricGI.shaderData);
        }
        else {
            this._baseRenderNode.volumetricGI = null;
            this._baseRenderNode.additionShaderData.delete(VolumeGIBlockName);
        }
        this._baseRenderNode.additionShaderData = this._baseRenderNode.additionShaderData;
        this._getIrradientMode();
    }
    setNodeCustomData(dataSlot, data) {
        this.renderNode.setNodeCustomData(dataSlot, data);
    }
    constructor() {
        super();
        this._sharedMaterials = [];
        this._sceneUpdateMark = -1;
        this._updateMark = -1;
        this._surportReflectionProbe = false;
        this._surportVolumetricGI = false;
        this._motionIndexList = -1;
        this._LOD = -1;
        this._lightmapScaleOffset = new Vector4();
        this._renderElements = [];
        this._baseRenderNode = this._createBaseRenderNode();
        this._baseRenderNode.setCommonUniformMap(this._getcommonUniformMap());
        this._baseRenderNode.shaderData = LayaGL.renderDeviceFactory.createShaderData(null);
        this._renderid = ++BaseRender._uniqueIDCounter;
        this._baseRenderNode.bounds = this._bounds = new Bounds(Vector3.ZERO, Vector3.ZERO);
        this._enabled = true;
        this._baseRenderNode.enable = true;
        this._materialsInstance = [];
        this.lightmapIndex = -1;
        this.receiveShadow = false;
        this._baseRenderNode.sortingFudge = 0.0;
        this.reflectionMode = ReflectionProbeMode.simple;
        if (!!this._calculateBoundingBox) {
            this._baseRenderNode.set_caculateBoundingBox(this, this._calculateBoundingBox);
        }
        if (!!this._renderUpdate) {
            this._baseRenderNode.set_renderUpdatePreCall(this, this._renderUpdate);
        }
        this.runInEditor = true;
        this._asynNative = true;
        this.boundsChange = true;
        this._baseRenderNode.renderbitFlag = 0;
        this._baseRenderNode.staticMask = 1;
        this.castShadow = false;
        this._baseRenderNode.renderNodeType = 0;
    }
    _setRenderElements() {
        var _a, _b, _c;
        let arrayElement = [];
        if (this._renderElements.length == 0 && this._inRenderList) {
            (_a = this.owner) === null || _a === void 0 ? void 0 : _a.scene._removeRenderObject(this);
        }
        if (((_b = this.owner) === null || _b === void 0 ? void 0 : _b.activeInHierarchy) && this.enabled && ((_c = this.owner) === null || _c === void 0 ? void 0 : _c.scene) && this._renderElements.length > 0 && !this._inRenderList)
            this.owner.scene._addRenderObject(this);
        this._renderElements.forEach(element => {
            arrayElement.push(element._renderElementOBJ);
        });
        this._baseRenderNode.setRenderelements(arrayElement);
    }
    _onWorldMatNeedChange(flag) {
        this.boundsChange = true;
        this._addReflectionProbeUpdate();
        this._batchRender && this._batchRender._updateOneRender(this);
    }
    _getcommonUniformMap() {
        return ["Sprite3D"];
    }
    _createBaseRenderNode() {
        return Laya3DRender.Render3DModuleDataFactory.createBaseRenderNode();
    }
    renderUpdate(context) {
    }
    _onAdded() {
        this._transform = this.owner.transform;
        this.owner._isRenderNode++;
        this.setRenderbitFlag(RenderBitFlag.RenderBitFlag_Editor, this.owner._getBit(NodeFlags.HIDE_BY_EDITOR));
        this._baseRenderNode.transform = this._transform;
        this._changeLayer(this.owner.layer);
        this._changeStaticMask(this.owner._isStatic);
    }
    _onEnable() {
        super._onEnable();
        this.owner.transform.on(Event.TRANSFORM_CHANGED, this, this._onWorldMatNeedChange);
        this.owner.on(Event.LAYER_CHANGE, this, this._changeLayer);
        this.owner.on(Event.STATIC_MASK, this, this._changeStaticMask);
        this._changeLayer(this.owner.layer);
        this._changeStaticMask(this.owner._isStatic);
        this.owner.scene._addRenderObject(this);
        this._setBelongScene(this.owner.scene);
    }
    _onDisable() {
        this.owner.transform.off(Event.TRANSFORM_CHANGED, this, this._onWorldMatNeedChange);
        this.owner.off(Event.LAYER_CHANGE, this, this._changeLayer);
        this.owner.off(Event.STATIC_MASK, this, this._changeStaticMask);
        this.owner.scene._removeRenderObject(this);
        this._setUnBelongScene();
        this.volume = null;
    }
    _onDestroy() {
        if (this.owner)
            this.owner._isRenderNode--;
        (this._motionIndexList !== -1) && (this._scene._sceneRenderManager.removeMotionObject(this));
        (this._scene) && this._scene.sceneRenderableManager.removeRenderObject(this);
        this._baseRenderNode.destroy();
        this._baseRenderNode = null;
        this._renderElements.forEach(element => {
            element.destroy();
        });
        this._renderElements = null;
        for (let i = 0, n = this._sharedMaterials.length; i < n; i++) {
            let m = this._sharedMaterials[i];
            m && !m.destroyed && m._removeReference();
        }
        this._sharedMaterials = null;
        this._bounds = null;
        this._lightmapScaleOffset = null;
        this._scene = null;
        this._transform = null;
        this._batchRender = null;
    }
    _getIrradientMode() {
        if (this.lightmapIndex >= 0) {
            this._baseRenderNode.irradientMode = IrradianceMode.LightMap;
        }
        else if (this.lightProbe) {
            this._baseRenderNode.irradientMode = IrradianceMode.VolumetricGI;
        }
        else {
            this._baseRenderNode.irradientMode = IrradianceMode.Common;
        }
    }
    _changeLayer(layer) {
        this._baseRenderNode.layer = layer;
    }
    _changeStaticMask(staticmask) {
        this._baseRenderNode.staticMask = staticmask;
    }
    _changeMaterialReference(lastValue, value) {
        (lastValue) && (lastValue._removeReference());
        value && value._addReference();
    }
    _getInstanceMaterial(material, index) {
        var insMat = material.clone();
        insMat.name = insMat.name + "(Instance)";
        this._materialsInstance[index] = true;
        this._changeMaterialReference(this._sharedMaterials[index], insMat);
        this._sharedMaterials[index] = insMat;
        return insMat;
    }
    _isSupportRenderFeature() {
        let preReflection = this._surportReflectionProbe;
        let prelightprob = this._surportVolumetricGI;
        this._surportReflectionProbe = false;
        this._surportVolumetricGI = false;
        var sharedMats = this._sharedMaterials;
        for (var i = 0, n = sharedMats.length; i < n; i++) {
            var mat = sharedMats[i];
            this._surportReflectionProbe || (this._surportReflectionProbe = this._surportReflectionProbe || (mat && mat._shader._supportReflectionProbe));
            this._surportVolumetricGI || (this._surportVolumetricGI = this._surportVolumetricGI || (mat && mat._shader._surportVolumetricGI));
        }
        if ((!preReflection && this._surportReflectionProbe) || (!prelightprob && this._surportVolumetricGI))
            this._addReflectionProbeUpdate();
    }
    _addReflectionProbeUpdate() {
        this._scene && this._scene._volumeManager.addMotionObject(this);
    }
    _setBelongScene(scene) {
        this._scene = scene;
        this._onWorldMatNeedChange(1);
        this._isSupportRenderFeature();
        this._batchRender && this._batchRender._batchOneRender(this);
        this.setLightmapIndex(this.lightmapIndex);
        this._statAdd();
    }
    _statAdd() {
        LayaGL.statAgent.recordCountData(StatElement.C_BaseRenderCount, 1);
    }
    _statRemove() {
        LayaGL.statAgent.recordCountData(StatElement.C_BaseRenderCount, -1);
    }
    _setUnBelongScene() {
        this._statRemove();
        this._scene._volumeManager.removeMotionObject(this);
        let batch = this._batchRender;
        this._batchRender && this._batchRender._removeOneRender(this);
        this._batchRender = batch;
        this._scene = null;
    }
    _needRender(boundFrustum, context) {
        if (boundFrustum)
            return boundFrustum.intersects(this.bounds);
        else
            return true;
    }
    _cloneTo(dest) {
        super._cloneTo(dest);
        dest.receiveShadow = this.receiveShadow;
        dest.sharedMaterials = this.sharedMaterials;
        dest.reflectionMode = this.reflectionMode;
        dest.castShadow = this.castShadow;
        dest.sortingFudge = this.sortingFudge;
    }
    setRenderbitFlag(flag, pass) {
        if (pass)
            this._baseRenderNode.renderbitFlag |= (1 << flag);
        else
            this._baseRenderNode.renderbitFlag &= ~(1 << flag);
    }
    get material() {
        var material = this._sharedMaterials[0];
        if (material && !this._materialsInstance[0]) {
            var insMat = this._getInstanceMaterial(material, 0);
            var renderElement = this._renderElements[0];
            (renderElement) && (renderElement.material = insMat);
        }
        return this._sharedMaterials[0];
    }
    set material(value) {
        this.sharedMaterial = value;
        this._isSupportRenderFeature();
    }
    get materials() {
        for (var i = 0, n = this._sharedMaterials.length; i < n; i++) {
            if (!this._materialsInstance[i]) {
                var insMat = this._getInstanceMaterial(this._sharedMaterials[i], i);
                var renderElement = this._renderElements[i];
                (renderElement) && (renderElement.material = insMat);
            }
        }
        return this._sharedMaterials.slice();
    }
    set materials(value) {
        this.sharedMaterials = value;
        this._isSupportRenderFeature();
    }
}
BaseRender._meshVerticeDefine = [];
BaseRender._uniqueIDCounter = 0;
BaseRender._tempBoundBoxCorners = [new Vector3(), new Vector3(), new Vector3(), new Vector3(), new Vector3(), new Vector3(), new Vector3(), new Vector3()];
BaseRender._defaultLightmapScaleOffset = new Vector4(1.0, 1.0, 0.0, 0.0);
